import React, { useCallback } from "react";
import { Line } from "react-chartjs-2";
import { CHART_THEME } from "../../../../constants/theme";
import { ChartMetric } from "../../../../cores/analytics/interface/ChartMetric";
import {
  charBasicDataset,
  barLineChartBasicOptions,
  createGradientFill,
} from "../../../utils/chartsUtils";

export const LineChart = (props: ChartMetric) => {
  const { labels, datasets } = props;

  const getColor = useCallback(
    (index: number) => CHART_THEME[index % CHART_THEME.length],
    []
  );

  const data = useCallback(
    (canvas?: any) => ({
      labels,
      datasets: datasets.map(({ label, color, data, fill, type }, index) => ({
        ...charBasicDataset,
        label,
        borderColor: color || getColor(index),
        pointBackgroundColor: color || getColor(index),
        fill,
        type,
        backgroundColor: canvas
          ? createGradientFill(canvas, color || getColor(index))
          : color || getColor(index),
        data: [...data],
      })),
    }),
    [datasets, getColor, labels]
  );

  return <Line data={data} options={barLineChartBasicOptions} />;
};
